import React from "react";
import { ProjectManagementPanel } from "@presentation/components/project/ProjectManagementPanel";
import { useWorkspaceContextStore } from "@presentation/stores/WorkspaceContextStore";
import { useRecordProjectVisit } from "@presentation/hooks/useRecordProjectVisit";

/**
Project settings (`/settings?scope=project&projectId=...`) - membership,
rename/move, storage and software-version configuration via `ProjectManagementPanel`. The project's
jobs live on the sibling `/teams/:teamId/projects/:projectId/jobs` page (linked via its own "View jobs" button).
*/
const ProjectConfigurationPage: React.FC<{ projectId: string }> = ({ projectId }) => {
  const teamId = useWorkspaceContextStore((state) => state.projects.find((project) => project.id === projectId)?.teamId ?? "");
  useRecordProjectVisit(teamId, projectId);

  return <ProjectManagementPanel key={projectId} projectId={projectId} />;
};

export default ProjectConfigurationPage;
